'use client';
import cn from 'classnames';
import Image from 'next/image';
import Text from '@/components/common/Text/Text';
import SlickCarousel from '@/components/common/SlickCarousel/SlickCarousel';

import './BenefitsGrid.style.scss';
import LineDivider from '@/components/common/LineDivider/LineDivider';

export type BenefitsGridItemProps = {
  className?: string;
  image: string;
  imageAltText: string;
  imageHeight: number;
  imageWidth: number;
  longText: string;
  link?: string;
  headline: string;
};

export type BenefitsGridProps = {
  className?: string;
  topHeadline: string;
  gridItems: BenefitsGridItemProps[];
};

export function BenefitsGridItem(props: BenefitsGridItemProps) {
  const {
    className = '',
    image,
    imageAltText,
    imageHeight,
    imageWidth,
    longText,
    headline
  } = props;
  return (
    <div className={cn('BenefitsGridItem', className)}>
      <Image
        className='BenefitsGridItem-image'
        src={image}
        height={imageHeight}
        width={imageWidth}
        alt={imageAltText}
      />
      <Text
        className='BenefitsGridItem-headline'
        variant='title-xs'
      >
        {headline.toUpperCase()}
      </Text>
      <Text
        className='BenefitsGridItem-text'
        variant='text-l'
      >
        {longText}
      </Text>
    </div>
  );
}

function BenefitsGrid(props: BenefitsGridProps) {
  const { className = '', topHeadline, gridItems } = props;
  return (
    <div className={cn('BenefitsGrid', className)}>
      <LineDivider className='BenefitsGrid-LineDivider-top' />
      <Text
        className='top-headline'
        variant='title-xl'
        italic
      >
        {topHeadline}
      </Text>
      <SlickCarousel
        className='BenefitsGrid-SlickCarousel'
        slickSettings={{
          dots: true,
          arrows: false
        }}
      >
        {gridItems.map((gridItem, index) => {
          return (
            <BenefitsGridItem
              className='mobile-gridItem'
              key={index}
              {...gridItem}
            />
          );
        })}
      </SlickCarousel>
      <div className='BenefitsGrid-desktopList'>
        {gridItems.map((gridItem, index) => {
          return (
            <BenefitsGridItem
              key={index}
              {...gridItem}
            />
          );
        })}
      </div>

      <LineDivider className='BenefitsGrid-LineDivider-bottom' />
    </div>
  );
}

export default BenefitsGrid;
